module.exports = __webpack_public_path__ + "img/people-32.373eb5be.png";